"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconArrowRightCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM12.7071 7.29283C13.0976 7.68336 13.0976 8.31652 12.7071 8.70705L9.70711 11.707C9.31658 12.0976 8.68342 12.0976 8.29289 11.707C7.90237 11.3165 7.90237 10.6834 8.29289 10.2928L9.58565 9.00008L4.00006 9.0004C3.44777 9.00043 3.00003 8.55274 3 8.00045C2.99997 7.44817 3.44766 7.00043 3.99994 7.0004L9.58593 7.00008L8.29289 5.70705C7.90237 5.31652 7.90237 4.68336 8.29289 4.29283C8.68342 3.90231 9.31658 3.90231 9.70711 4.29283L12.7071 7.29283Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M9.99976 19C5.02919 19 0.999756 14.9706 0.999756 10C0.999756 5.02944 5.02919 1 9.99976 1C14.9703 1 18.9998 5.02944 18.9998 10C18.9998 14.9706 14.9703 19 9.99976 19ZM15.9998 10.0002C15.9998 10.2654 15.8944 10.5197 15.7069 10.7073L11.7069 14.7073C11.3163 15.0978 10.6832 15.0978 10.2927 14.7073C9.90213 14.3168 9.90212 13.6836 10.2926 13.2931L12.5857 11H4.99976C4.44747 11 3.99976 10.5523 3.99976 10C3.99976 9.44772 4.44747 9 4.99976 9H12.5854L10.2927 6.70732C9.90213 6.31679 9.90212 5.68363 10.2926 5.2931C10.6832 4.90258 11.3163 4.90257 11.7069 5.2931L15.7069 9.29305C15.8944 9.48058 15.9998 9.73494 15.9998 10.0002Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM14.7071 7.29289L18.7071 11.2929C19.0976 11.6834 19.0976 12.3166 18.7071 12.7071L14.7071 16.7071C14.3166 17.0976 13.6834 17.0976 13.2929 16.7071C12.9024 16.3166 12.9024 15.6834 13.2929 15.2929L15.5858 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H15.5858L13.2929 8.70711C12.9024 8.31658 12.9024 7.68342 13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31ZM26 15.9999C26 16.4203 25.8235 16.8215 25.5136 17.1056L19.5136 22.6058C18.9029 23.1656 17.9541 23.1244 17.3943 22.5137C16.8345 21.903 16.8757 20.9542 17.4864 20.3944L20.6438 17.5H7.5C6.67157 17.5 6 16.8284 6 16C6 15.1716 6.67157 14.5 7.5 14.5H20.6438L17.4864 11.6058C16.8757 11.046 16.8345 10.0972 17.3942 9.48651C17.954 8.87582 18.9029 8.83455 19.5136 9.39433L25.5136 14.8941C25.8235 15.1782 26 15.5794 26 15.9999Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;